import QuestionAnswersView from "./QuestionAnswersView";

function QuestionAnswers({ questionAnswers, onClose }) {
  return (
    <QuestionAnswersView onClose={onClose} questionAnswers={questionAnswers} />
  );
}

export default QuestionAnswers;
